<template>
    <div class="m-my-combat" v-if="myBetInfo">
        <div class="updown-info" v-if="detailTimeStatus===2">
            <div class="box-card" style="margin-bottom:10px;" v-if="myBetInfo.nextInfo">
                <h1 class="mg-none"><strong class="tody-bt">竞猜结果</strong> <router-link class="right" to="/combat">点击查看 &rsaquo; </router-link></h1>
            </div>
            <template v-if="myBetInfo.nextInfo">                
                <my-combat-info :data="myBetInfo.nextInfo" type="nextInfo" :state="detailTimeStatus"></my-combat-info>
            </template>
            <template v-else-if="myBetInfo.info">
                <my-combat-info :data="myBetInfo.info" type="info"  :state="detailTimeStatus"></my-combat-info>
            </template>
        </div>
        <div class="updown-info" v-else>
            <template v-if="myBetInfo.info">
                <my-combat-info :data="myBetInfo.info" type="info" :state="detailTimeStatus"></my-combat-info>
            </template>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import MYbetInfo from '../combat/my-combat-info'
    export default {
        data() {
            return {
                
            }
        },
        components:{
            'my-combat-info' : MYbetInfo
        },
        computed: {
            ...mapGetters('home', ['myBetInfo', 'detailTimeStatus'])
        },
    }
</script>